// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeHubApi = class EdgeHubApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param GetAccountRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async hubV1GetAccount(GetAccountRequestModel, x_program_id) {
        const _url_ = '/edge/hub/v1/GetAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetAccountRequestModel' is not null or undefined
        if (GetAccountRequestModel === null || GetAccountRequestModel === undefined) {
            throw new Error('Required parameter GetAccountRequestModel was null or undefined when calling hubV1GetAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetAccountRequestModel, "GetAccountRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1GetAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param GetPatientRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async hubV1GetPatient(GetPatientRequestModel, x_program_id) {
        const _url_ = '/edge/hub/v1/GetPatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetPatientRequestModel' is not null or undefined
        if (GetPatientRequestModel === null || GetPatientRequestModel === undefined) {
            throw new Error('Required parameter GetPatientRequestModel was null or undefined when calling hubV1GetPatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetPatientRequestModel, "GetPatientRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1GetPatientDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SavePatientRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async hubV1SavePatient(SavePatientRequestModel, x_program_id) {
        const _url_ = '/edge/hub/v1/SavePatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SavePatientRequestModel' is not null or undefined
        if (SavePatientRequestModel === null || SavePatientRequestModel === undefined) {
            throw new Error('Required parameter SavePatientRequestModel was null or undefined when calling hubV1SavePatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SavePatientRequestModel, "SavePatientRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1SavePatientDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param HubSearchAccountsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async hubV1SearchAccounts(HubSearchAccountsRequestModel, x_program_id) {
        const _url_ = '/edge/hub/v1/SearchAccounts';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'HubSearchAccountsRequestModel' is not null or undefined
        if (HubSearchAccountsRequestModel === null || HubSearchAccountsRequestModel === undefined) {
            throw new Error('Required parameter HubSearchAccountsRequestModel was null or undefined when calling hubV1SearchAccounts.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(HubSearchAccountsRequestModel, "HubSearchAccountsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1SearchAccountsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SearchPatientsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async hubV1SearchPatients(SearchPatientsRequestModel, x_program_id) {
        const _url_ = '/edge/hub/v1/SearchPatients';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SearchPatientsRequestModel' is not null or undefined
        if (SearchPatientsRequestModel === null || SearchPatientsRequestModel === undefined) {
            throw new Error('Required parameter SearchPatientsRequestModel was null or undefined when calling hubV1SearchPatients.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SearchPatientsRequestModel, "SearchPatientsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1SearchPatientsDefaultResponse");
        }
        return response;
    }
};
EdgeHubApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeHubApi);
export { EdgeHubApi };
//# sourceMappingURL=edgeHubApi.js.map